module.exports = __webpack_public_path__ + "static/media/myself.2dd6f105.jpg";